export default __webpack_public_path__ + "static/media/Fosco Maraini.519aa9da.jpg";